import React, { Suspense, lazy } from 'react'
// import Posts from './Posts'
import { PostAppProvider } from './context/PostContext'
import { Spinner } from 'react-bootstrap'
import { ToastContainer } from 'react-toastify'
const Posts = lazy(() => import('./Posts'))


const PostsHome = () => {
    return (
        <>
            <PostAppProvider>
                <Suspense fallback={
                    <>
                        <Spinner className='spinner'/>
                       
                    </>
                }>
                    <Posts />
                </Suspense>
              <ToastContainer/>
            </PostAppProvider>

        </>
    )
}

export default PostsHome